import { css } from 'emotion';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import analytics from 'site-react/core/Analytics';
import HubbleLogo from 'site-react/core/HubbleLogo';
import HubbleLogoText from 'site-react/navigation/DesktopNav/logo';
import theme from 'site-react/theme';

const hideFromDesktop = css`
  @media (min-width: ${theme.breakpoints.sm}px) {
    display: none;
  }
`;

const hideFromMobile = css`
  @media (max-width: ${theme.breakpoints.sm}px) {
    display: none;
  }
`;

const navigationLogoStyle = css`
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  margin-right: ${theme.spacing.sm}px;
`;

const navigationLogoClicked = () => {
  analytics.track('Navigation Logo Clicked');
};

const NavigationLogo = ({ isLogoTextDisplayed }) => (
  <Link href="/">
    <a className={navigationLogoStyle} href="/" onClick={navigationLogoClicked}>
      {isLogoTextDisplayed ? (
        <>
          <div className={hideFromMobile}>
            <HubbleLogoText height="48" />
          </div>
          <div className={hideFromDesktop}>
            <HubbleLogo color="currentColor" size={48} />
          </div>
        </>
      ) : (
        <HubbleLogo color="currentColor" size={48} />
      )}
    </a>
  </Link>
);

NavigationLogo.defaultProps = {
  isLogoTextDisplayed: false,
};

NavigationLogo.propTypes = {
  isLogoTextDisplayed: PropTypes.bool,
};

export default NavigationLogo;
